import React, {useState} from "react";
import Price from "@app/react/components/Price/Price.jsx";
import AppModal from "@app/react/components/AppModal/AppModal.jsx";
import IconInfo from "@img/icon-info.svg?react";
import IconBox from "@img/icon-box.svg?react";
import IconTrash from "@img/icon-trash.svg?react";
import './styles.scss';

export default function CartProductVariationItem({productVariation, quantity, onChange, onDeleteButtonClick}) {
  // Controlli di quantita e rimozione dipendono dal proprio callback, in modo
  // indipendente: una riga puo essere modificabile ma non rimuovibile (o il
  // contrario). Senza onChange la quantita e mostrata come valore statico
  // (vedi CartReadonly).
  const editable = typeof onChange === 'function';
  const deletable = typeof onDeleteButtonClick === 'function';

  function handleInputChange(evt) {
    const val = parseInt(evt.target.value)
    if (!isNaN(val)) {
      onChange(val)
    }
  }

  const [showInfo, setShowInfo] = useState(false);
  const minOk = quantity >= productVariation.min_qty;
  const multOk = quantity % productVariation.mult_qty === 0;
  const isValid = quantity > 0 && minOk && multOk;
  // Senza controlli non c'e nulla da correggere: evidenziare min/multipli
  // segnalerebbe un errore su una quantita non piu modificabile.
  const rowClass = 'cart-product-variation-item'
    + (editable && quantity > 0 && isValid ? ' is-valid' : '')
    + (editable && quantity > 0 && !isValid ? ' is-invalid' : '')
    + (deletable ? ' is-deletable' : '')
    + (editable ? ' is-editable' : '')
  ;

  return <>
    <div className={rowClass}>
      <div className='cart-product-variation-item__sku'>
        <label>{Drupal.tt('codice')}</label>
        <div>
          {productVariation.sku}
          <div className="actions">
            <IconInfo onClick={() => setShowInfo(true)} style={{cursor: 'pointer'}} />
          </div>

        </div>
      </div>
      <div className='cart-product-variation-item__title'>
        <label>{Drupal.tt('descrizione')}</label>
        <div>
          {productVariation.title}
        </div>
      </div>
      <div className='cart-product-variation-item__price'>
        <label>{Drupal.tt('prezzo')}</label>
        <div>
          <Price value={productVariation.price} />
        </div>
      </div>
      <div className='cart-product-variation-item__min_mult_qty'>
        <label>{Drupal.tt('min./multip.')}</label>
        <div>
          <span className={editable && quantity > 0 && !minOk ? 'text-invalid' : ''}>{productVariation.min_qty}</span>
          /
          <span className={editable && quantity > 0 && !multOk ? 'text-invalid' : ''}>{productVariation.mult_qty}</span>
        </div>
      </div>
      <div className={'cart-product-variation-item__qty'}>
        {deletable &&
          <button onClick={() => onDeleteButtonClick()} className="btn-delete"><IconTrash/></button>
        }
        {editable ? <>
          <button onClick={() => onChange(Math.max(quantity - 1, 0))} disabled={quantity===0}>-</button>
          <input type='text' value={quantity} onChange={handleInputChange} />
          <button onClick={() => onChange(quantity + 1)}>+</button>
        </> : <>
          <label>{Drupal.tt('quantità')}</label>
          <div>{quantity}</div>
        </>}
      </div>
    </div>
    <AppModal show={showInfo} onHide={() => setShowInfo(false)}>
      <div className='variation-info'>
        <div className='variation-info__header'>
          {productVariation.image &&
            <img src={productVariation.image} alt={productVariation.sku} className='variation-info__image' />
          }
          <div>
            <div className='variation-info__sku'>{productVariation.sku}</div>
            <div className='variation-info__title'>{productVariation.title}</div>
          </div>
        </div>

        <div className='variation-info__details'>
          <div>
            <label>{Drupal.tt('imballo')}</label>
            <span>
              {productVariation.packaging?.box_type ?? '—'}<br/>
              {productVariation.packaging?.qty ? productVariation.packaging?.qty+' '+Drupal.tt('pz') : '—'}
            </span>
          </div>
          <div>
            <label>{Drupal.tt('lead time')}</label>
            <span>
              {productVariation.lead_time != null
                ? productVariation.lead_time % 7 === 0
                  ? `${productVariation.lead_time / 7} ${Drupal.tt('settimane')}`
                  : `${productVariation.lead_time} ${Drupal.tt('gg')}`
                : '—'}
            </span>
          </div>
          <div>
            <label>{Drupal.tt('peso netto')}</label>
            <span>{productVariation.packaging?.weight != null ? `${productVariation.packaging.weight} kg` : '—'}</span>
          </div>
        </div>
        {productVariation.color?.id && (
          <div className='variation-info__color'>
            <label>{Drupal.tt('colore')}</label>
            <div className='variation-info__color-content'>
              {productVariation.color.image &&
                <img src={productVariation.color.image} alt={productVariation.color.name ?? ''} className='variation-info__color-image' />
              }
              {productVariation.color.name &&
                <span>{productVariation.color.name}</span>
              }
            </div>
          </div>
        )}
      </div>
    </AppModal>
  </>
}
